import { Container } from "@mui/material";
import { Navigate, useLocation, useParams } from "react-router-dom";
import RecordProducer from "modules/record/record-producer/components/RecordProducer";
import Translate from "component/global/translation/translation-component";
import { useRecordProducerQuery } from "../hooks/useRecordProducerQuery";
import { useTables } from "app/hooks/useTables";

const RecordProducerPage = () => {

    const { tableName, id } = useParams();
    const location = useLocation();
    const { record } = useRecordProducerQuery(tableName || "", id);
    const { data: tables } = useTables();

    if (!tableName) {
        return <Translate text="Table name is required" />;
    }

    const className = record?.data?.sys_class_name;
    const concreteTable = tables?.find(table => table.name === className);
    if (id && className && className !== tableName && concreteTable?.parent_table_name === tableName) {
        return <Navigate replace to={{
            pathname: `/home/workspace/${encodeURIComponent(className)}/record/${encodeURIComponent(id)}`,
            search: location.search,
            hash: location.hash,
        }} />;
    }

    return (
        <Container sx={{ marginTop: 1, marginBottom: 1 }}>
            <RecordProducer tableName={tableName} sysId={id} />
        </Container>
    );
};

export default RecordProducerPage;
